import * as React from 'react';
import type { Echo } from '@/types';
import { EchoAvatar } from '@/components/common/EchoAvatar';

/** Props for the {@link GroupChatEchoChip} component. */
interface GroupChatEchoChipProps {
  /** Echo to display in the chip. */
  echo: Echo;
  /** Callback when the remove (X) button is clicked. */
  onRemove: () => void;
}

/** Compact chip showing a selected echo's avatar and name with a remove button. */
export const GroupChatEchoChip: React.FC<GroupChatEchoChipProps> = ({ echo, onRemove }) => (
  <div className='flex items-center gap-1.5 rounded-full py-1'>
    <EchoAvatar src={echo.imageUrl} alt={echo.name} initials={echo.name.slice(0, 2)} size={23} />
    <span className='font-proxima text-[10px] font-bold uppercase leading-[20px] tracking-normal text-brand-800'>
      {echo.name}
    </span>
    <button
      type='button'
      onClick={onRemove}
      className='ml-0.5 flex size-4 items-center justify-center rounded-full transition-opacity hover:opacity-70'
      aria-label={`Remove ${echo.name}`}
    >
      <svg width='8' height='8' viewBox='0 0 8 8' fill='none'>
        <path d='M1 1l6 6M7 1L1 7' stroke='#1A1036' strokeWidth='1.5' strokeLinecap='round' />
      </svg>
    </button>
  </div>
);
